import { CardBody, CardContainer } from 'src/components/atoms';
import { ShadowsSize } from 'src/components/foundations/tokens';
import { ChangePasswordNew } from 'src/components/organisms/ChangePasswordNew/ChangePasswordNew';
import {
  StyledContainer,
  StyledDescription,
  StyledHeader,
} from './ChangePassword.styles';

export const ChangePassword = () => {
  return (
    <StyledContainer>
      <StyledHeader>Update Password</StyledHeader>
      <StyledDescription>
        Create a strong password to keep your account secure. <br />
        Start typing to see guidelines below.
      </StyledDescription>
      <CardContainer $width="320px" $shadowSize={ShadowsSize.large}>
        <CardBody>
          <ChangePasswordNew
            data-testid="change-password"
            buttonText={'Update password'}
            updateWithToken={false}
          />
        </CardBody>
      </CardContainer>
    </StyledContainer>
  );
};

export default ChangePassword;
